// extracted by mini-css-extract-plugin
module.exports = {"title":"lector-courses_title__M2b0w","cardsWrapper":"lector-courses_cardsWrapper__GYXf_","cardWrapper":"lector-courses_cardWrapper__i2gjL"};